import { Object3D } from "three";
import { OrthographicCamera, View } from "@react-three/drei";
import Lights from "../../Lights.tsx";
import { PrototypeCard } from "./PrototypeCard.tsx";

type PrototypeCardViewProps = {
  index: number;
  model: Object3D;
};

export function PrototypeCardView({ index, model }: PrototypeCardViewProps) {
  return (
    <View className={"inline-block w-36 h-48"}>
      {/*<color attach="background" args={["#fed200"]} />*/}
      <OrthographicCamera makeDefault position={[0, 0, 4]} zoom={40} />
      {/*<OrbitControls makeDefault />*/}
      <Lights />
      <PrototypeCard model={model} />
    </View>
  );
}
